import React, { useContext } from "react";
import { RotatingLines } from 'react-loader-spinner';
import { createUseStyles } from "react-jss";
import { EmpdContext } from '../../../../../Context'
import DashboardCard from "./DashboardCard";
import classNames from "classnames";
import Button from "../../../../../Components/Button";
import { questionSquare } from "../../../../../Assets/Images";

interface Props {
  className?: string;
}

const useStyles = createUseStyles({
  root: {},
  diagnosedButton: {
    textAlign: "center",
  },
  diagnosedQuestion: {
    padding: 30,
    backgroundColor: "#f6bb6021",
    border: "1px solid #f6bb60",
    borderRadius: "5px",
  },
  diagnosedQuestionHeader: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    "& h4": {
      fontSize: "1.35em",
      margin: 0,
    },
  },
  notDiagnosedButton: {
    backgroundColor: "#e1e5ec !important",
    flexBasis: "100%",
    textAlign: "center",
  },
  diagnosedContainer: {
    marginTop: "50px",
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
  },
  questionMark: {
    height: 25,
    width: "auto",
    marginRight: 15,
  },
});

const recipient = 'globalempd@emory.edu'
const subject = 'Patient Intake Request'
const body = 'Please provide the following information:\n\nName:\n\nPhone Number:\n\nConfirmed diagnosis of EMPD:\n\n\nIf you can answer any of the following, it will help us direct your request more effectively:\n\nDiagnosis date:\n\nPrior treatment: surgery (including Moh’s), radiation, systemic therapy:\n\nCurrent state of disease (NED, active local, active metastatic):'

const useMyContext = () => {
    const context = useContext(EmpdContext)
    if( !context ) {
        throw new Error("No provider found for Context")
    }
    return context
}

const ClinicalIntake = ({ className }: Props) => {
  const context = useMyContext()
  const { isLoading } = context
  const classes = useStyles();

  const encodedSubject = encodeURIComponent(subject)
  const encodedBody = encodeURIComponent(body)

  const handleClick = () => {
  	window.location.href = `mailto:${recipient}?subject=${encodedSubject}&body=${encodedBody}`
  };

  if( isLoading ) {
	return (
		<DashboardCard
			className={classNames(classes.root, className)}
	    >
			<RotatingLines
				strokeColor="#152E54"
	            strokeWidth="3"
    	        animationDuration="1.0"
        	    width="48"
            	visible={true}
        	/>
		</DashboardCard>
	)
  } else {
  return (
    <DashboardCard
      title={"Clinical Contact"}
      className={classNames(classes.root, className)}
    >
      {!isLoading && (
      <div className={classes.diagnosedQuestion}>
        <div className={classes.diagnosedQuestionHeader}>
		  	<img
            	src={questionSquare}
	            alt="question-mark"
    	        className={classes.questionMark}
        	  />
          <h4>{`Contact the clinical team?`}</h4>
        </div>
        <p>{`For patient referrals or clinical questions related to EMPD, please click here to contact the Emory Winship clinical team. Our staff will help direct your inquiry to the appropriate clinic or scheduling team.`}</p>
	        <div className={classes.diagnosedContainer}>
    	      <Button
        	    className={classes.diagnosedButton}
	            label={'Contact the Emory Winship Clinical Team'}
    	        onClick={() => handleClick()}
	          />
        	</div>
      </div>
      )}
    </DashboardCard>
  );
	}
};

export default ClinicalIntake;
